import { ApiClient, ApiClientPdf } from "../../utils/api-client";

export const requestGradeByIdentifier = async (identifier, countryCode) => {
  try {
    const response = await ApiClient.get(`/debtor`, {
      params: {
        identificationOrName: identifier,
        countryCode: countryCode
      }
    });
  
    let objectToReturn = response.data.debtors;

    if(response.status === 204) {
      objectToReturn = {
        "isGrade": true,
        "debtor": null
      }
    }
    return objectToReturn;
  } catch (e) {
    return await {
      "isGrade": true,
      "debtor": null
    }
  }
}

export const requestGrade = async (companyId) => {
  try {
    const response = await ApiClient.get(process.env.REACT_APP_SERVICE_PATH_ENV.concat(`/api/grade`), {
      params: {
        companyId: companyId
      }
    });
  
    let objectToReturn = response.data.isGrade;

    if(response.status === 204) {
      objectToReturn = {
        "isGrade": false
      }
    }
    return objectToReturn;
  } catch (e) {
    return await {
      "isGrade": false
    }
  }
}

export const requestCompanyInfo = (company) => {
  console.log(company);
}

export const getPrintRequest = async requestId => {
  try {
    const response = await ApiClientPdf.get(`/requests/${requestId}/pdf`);
    return response.data;
  } catch (e) {
    return await {}
  }
}

export const sendPrintRequest = async requestId => {
  try {
    await ApiClientPdf.get(`/requests/${requestId}/print`);
  } catch (e) {
    return await {}
  }
}